import EnrolmentsSerializer from './base';

export default class AttendanceSurvey extends EnrolmentsSerializer {}
